import { render, staticRenderFns } from "./OrgModal.vue?vue&type=template&id=c42196c0&scoped=true"
import script from "./OrgModal.vue?vue&type=script&lang=js"
export * from "./OrgModal.vue?vue&type=script&lang=js"
import style0 from "./OrgModal.vue?vue&type=style&index=0&id=c42196c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42196c0",
  null
  
)

export default component.exports